export enum WidgetColors {
	'#366F92',
	'#C5BDF6',
	'#00C5C6',
	'#FFD364',
	'#D03F48',
	'#F785BC',
	'#CAE495',
	'#7469F1',
	'#F29A76',
	'#3BAFFF',
	'#FF7F5D',
	'#F3EFD3',
	'#FFBEDA',
	'#2D9E78',
	'#FFFF93',
	'#1D88B8',
	'#F04497',
	'#33740B',
	'#9EDDD7',
	'#A30F16',
	'#D2BF9C',
	'#FFC297',
	'#9DE9F7',
	'#B8938B',
	'#23C370',
	'#EB9797',
	'#3B2FC7',
	'#5B9FAF',
}
